module.exports = __webpack_public_path__ + "static/media/documentIcon.d3151123.svg";